module.exports = __webpack_public_path__ + "img/software_img01.80e016c7.png";